<template>
  <div
    class="wt-mce-color-palette"
    :class="{ opened: menuOpened, flipPanel: flipPanel }"
    v-click-outside="clickOutside"
  >
    <div class="wt-mce-color-palette-inner" @click="openPanel">
      <div
        class="wt-chosen-color-preview"
        :style="previewStyle"
        :class="{ transparent: isCurrentColorTransparent }"
      ></div>
      <span class="wt-chosen-color-arrow-down"></span>
    </div>
    <div ref="panel" class="wt-mce-color-palette-panel">
      <div class="wt-mce-color-palette-title">Theme</div>
      <ul class="wt-mce-color-palette-panel-list">
        <li
          v-for="(tmpColor, key) in customColors"
          :key="key"
          :style="{ background: tmpColor }"
          @click="changeColor(tmpColor, 1)"
        ></li>
      </ul>
      <ul class="wt-mce-color-palette-panel-list">
        <li
          :key="key"
          v-for="(tmpColor, key) in colorsPalette"
          :style="{ background: tmpColor.color }"
          @click="changeColor(tmpColor.color, 1)"
        ></li>
        <li class="transparent" @click="alpha = 0"></li>
      </ul>
      <!--
      <div class="wt-mce-color-palette-title">Opacity</div>
      <input type="range" v-model="alpha" number min="0" step="0.1" max="1">
      -->
      <div class="wt-slider wt2-sg -custom-css">
        <wt-slider ref="slider" @change="setAlpha">
          <span slot="header">Opacity</span>
        </wt-slider>
      </div>
    </div>
  </div>
</template>

<script>
import app from 'app';
import WtSliderComponent from 'components/sliders/wtSlider.component.vue';

export default {
  components: {
    'wt-slider': WtSliderComponent,
  },
  data: function () {
    return {
      menuOpened: false,
      flipPanel: false,
      currentColor: tinycolor(this.color),
    };
  },
  props: {
    color: {
      type: String,
      default: '',
    },
    colorKey: {
      type: Number,
    },
    colorsPalette: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  computed: {
    previewStyle() {
      return {
        background: this.currentColor.toRgbString(),
      };
    },
    alpha: {
      get() {
        return this.currentColor.getAlpha();
      },
      set(newAlpha) {
        this.currentColor.setAlpha(newAlpha);
        this.changeColor();
      },
    },
    isCurrentColorTransparent() {
      return this.alpha === 0;
    },
    customColors() {
      return window.localStorage.customBoxColors
        ? JSON.parse(window.localStorage.customBoxColors)
        : [];
    },
  },
  mounted: function () {
    this.$refs.slider.curValue = Math.round(this.currentColor.getAlpha() * 100);
  },
  watch: {
    color() {
      this.currentColor = tinycolor(this.color); // color updated from outside component
    },
  },
  methods: {
    setAlpha(newVal) {
      this.alpha = newVal / 100;
    },
    changeColor(color, alpha) {
      if (color) {
        this.currentColor = tinycolor(color);
      }
      if (alpha) {
        this.$refs.slider.curValue = 100 * alpha;
        this.currentColor.setAlpha(alpha);
      }
      this.$emit('color-changed', {
        colorKey: this.colorKey,
        color: app.namespace.Util.hexToRgba(
          this.currentColor.toHexString(),
          this.currentColor.getAlpha()
        ),
      });
    },
    clickOutside() {
      if (this.menuOpened) {
        this.menuOpened = false;
      }
    },
    openPanel(e) {
      this.menuOpened = !this.menuOpened;
      // wait for the class change apply
      this.$nextTick(() => {
        // check if the the bottom of the span plus
        // the height of the panel is greater then
        // the window innerHeight and if so flip the panel
        this.flipPanel =
          e.target.getBoundingClientRect().bottom +
            this.$refs.panel.getBoundingClientRect().height +
            10 >
          window.innerHeight;
      });
    },
  },
};
</script>
